import baseRoute from '../baseRoute';

export default `${baseRoute}/agency` as const;
